import React from "react";
import IButton from "./IButton";
import ButtonAction from "./ButtonAction";
import ButtonType from "./ButtonType";
import AppIcons from "../../../utils/AppIcons";

const tailwindDynamiClassesFix = {
  root: "btn-primary",
  one: "btn-primary-fill",
  two: "btn-cancel-fill",
  three: "btn-delete-fill",
  four: "btn-use-fill",
};

function Button({
  purpose,
  type = ButtonType.FILL_ICON_TEXT,
  label,
  onClick = () => {},
  isSubmit = false,
  className = "",
  activeState = 0,
  disabled = false,
}: IButton) {
  let icon = undefined;
  let css = tailwindDynamiClassesFix.root;

  switch (purpose) {
    case ButtonAction.BACK:
      icon = AppIcons.BACK;
      break;
    case ButtonAction.CREATE:
    case ButtonAction.UPDATE:
      icon = AppIcons.ADD;
      break;
    case ButtonAction.CANCEL:
      icon = AppIcons.CANCEL;
      css = "btn-cancel";
      break;
    case ButtonAction.SAVE:
      icon = AppIcons.SAVE;
      break;
    case ButtonAction.EDIT:
      icon = AppIcons.EDIT;
      break;
    case ButtonAction.DELETE:
      icon = AppIcons.DELETE;
      css = "btn-delete";
      break;
    case ButtonAction.MAP:
      icon = AppIcons.MAP;
      break;
    case ButtonAction.DOWNLOAD:
      icon = AppIcons.DOWNLOAD;
      break;
    case ButtonAction.SEARCH:
      icon = AppIcons.SEARCH;
      break;
    case ButtonAction.USE:
      icon = AppIcons.UNITY;
      css = type !== ButtonType.ICON_TEXT ? "btn-use" : "";
      break;
    case ButtonAction.LIST:
      icon = AppIcons.LIST;
      break;
    case ButtonAction.GRID:
      icon = AppIcons.GRID;
      break;
    case ButtonAction.CHECKED_YES:
      icon = AppIcons.SQUARE_CHECK;
      break;
    case ButtonAction.CHECKED_NO:
      icon = AppIcons.SQUARE;
      break;
    case ButtonAction.SHARE:
      icon = AppIcons.SHARE;
      break;
    case ButtonAction.INFO:
      icon = AppIcons.INFO;
      break;
    case ButtonAction.EXPLORE:
      icon = AppIcons.EYE;
      break;
  }

  switch (type) {
    case ButtonType.FILL_ICON_TEXT:
    case ButtonType.FILL_ICON:
    case ButtonType.FILL_TEXT:
      css = `${css}-fill`;
      break;
    case ButtonType.ICON:
      break;
  }

  if (activeState === 1) {
    // Make button highlighted
    css = `${css} bg-blue-700`;
  } else if (activeState === 2) {
    // Make button not highlighted
    css = `${css} bg-blue-400`;
  } else {
    // Return to before
    css = `${css}`;
  }

  let showIcon = type !== ButtonType.FILL_TEXT && type !== ButtonType.TEXT;
  let showText = type !== ButtonType.FILL_ICON && type !== ButtonType.ICON;
  const typeAttr = isSubmit ? "submit" : "button";

  return (
    <button
      onClick={(e) => {
        if (disabled) return;
        e.stopPropagation();
        onClick();
      }}
      className={`${css} ${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      type={typeAttr}
      disabled={disabled}
    >
      {showIcon && <>{icon}</>}
      {showText ? label : null}
    </button>
  );
}

export default Button;
